import script from "./OurAppView.vue?vue&type=script&setup=true&lang=ts"
export * from "./OurAppView.vue?vue&type=script&setup=true&lang=ts"

import "./OurAppView.vue?vue&type=style&index=0&id=42d142f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42d142f2"]])

export default __exports__